export function initQuickview() {
  document.addEventListener('click', function (e) {
    const target = e.target.closest('.bls__quickview-button-js');
    if (target) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    } else {
      return;
    }
    const productHandle = target.dataset.productHandle;
    target.classList.add('btn-loading');
  
    fetch(`${window.Shopify.routes.root}products/${productHandle}/?section_id=product-quickview`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const quickviewHTML = html.querySelector("#shopify-section-product-quickview");
  
        if (quickviewHTML) {
          const quickviewBox = EasyDialogBox.create(
            "dlg-product-quickview",
            "dlg dlg-disable-heading dlg-multi dlg-disable-footer dlg-disable-drag",
            "",
            quickviewHTML.innerHTML
          );
          quickviewBox.onClose = quickviewBox.destroy;
          quickviewBox.show();
  
          BlsColorSwatchesShopify.init?.();
          Shopify.swiperSlideQickview?.();
          Shopify.eventFlashSold?.("dlg");
          Shopify.eventCountDownTimer?.("dlg");
          BlsReloadSpr?.init?.();
          Shopify.PaymentButton?.init?.();
          BlsLazyloadImg?.init?.();
        }
      })
      .catch(console.error)
      .finally(() => {
        target.classList.remove('btn-loading');
        target.querySelectorAll(".loader-icon").forEach(el => el.remove());
      });
  }, true);
}